import { render, staticRenderFns } from "./ReceiveEdit_Received.vue?vue&type=template&id=2a2165c6&"
import script from "./ReceiveEdit_Received.vue?vue&type=script&lang=js&"
export * from "./ReceiveEdit_Received.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports